export { INCOMING_INVOICE_KIND_LABEL } from "@msuite/utils/incoming-invoices";
